/**
 * Selection Reducers for RemitSlice
 * 
 * Handles claim and service line selection within a remit.
 */

import { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import { RemitSliceState } from '../state';

/**
 * Set the selected claim ID
 */
export const setSelectedClaimId: CaseReducer<
  RemitSliceState,
  PayloadAction<string | null>
> = (state, action) => {
  state.selectedClaimId = action.payload;
  // Clear service line selection when claim changes
  state.selectedServiceLineId = null;
};

/**
 * Set the selected service line ID
 */
export const setSelectedServiceLineId: CaseReducer<
  RemitSliceState,
  PayloadAction<string | null>
> = (state, action) => {
  state.selectedServiceLineId = action.payload;
};

/**
 * Clear all selections
 */
export const clearSelections: CaseReducer<RemitSliceState> = (state) => {
  state.selectedClaimId = null;
  state.selectedServiceLineId = null;
};

/**
 * Select next claim in the list
 */
export const selectNextClaim: CaseReducer<RemitSliceState> = (state) => {
  if (!state.currentRemit || state.currentRemit.claims.length === 0) return;
  
  const claims = state.currentRemit.claims;
  if (!state.selectedClaimId) {
    state.selectedClaimId = claims[0].id;
  } else {
    const currentIndex = claims.findIndex((c) => c.id === state.selectedClaimId);
    if (currentIndex < claims.length - 1) {
      state.selectedClaimId = claims[currentIndex + 1].id;
      state.selectedServiceLineId = null;
    }
  }
};

/**
 * Select previous claim in the list
 */
export const selectPreviousClaim: CaseReducer<RemitSliceState> = (state) => {
  if (!state.currentRemit || state.currentRemit.claims.length === 0) return;
  
  const claims = state.currentRemit.claims;
  if (!state.selectedClaimId) {
    state.selectedClaimId = claims[claims.length - 1].id;
  } else {
    const currentIndex = claims.findIndex((c) => c.id === state.selectedClaimId);
    if (currentIndex > 0) {
      state.selectedClaimId = claims[currentIndex - 1].id;
      state.selectedServiceLineId = null;
    }
  }
};
